import { Vec, type Vector } from "@common/utils/vector";

/** a grenade gas puff's reach at its size 1 (its hitbox radius) plus a player's radius */
export const PUFF_REACH = 5 + 2.25;
export const GAS_PUFF = "gas_grenade_particle";

export interface GasPuff {
    readonly idString: string
    readonly position: Vector
    /** the puff's current size (its hitbox grows with it) */
    readonly scale: number
}

/** is this spot inside any grenade gas puff? */
export const inGrenadeGas = (where: Vector, puffs: Iterable<GasPuff>): boolean => {
    for (const puff of puffs) {
        if (puff.idString !== GAS_PUFF) continue;
        const reach = PUFF_REACH * Math.max(0.3, puff.scale);
        if (Vec.squaredLen(Vec.sub(puff.position, where)) <= reach * reach) return true;
    }
    return false;
};

/** the visor frame: a gas mask on, and in gas (a grenade's or the zone's) */
export const showVisor = (masked: boolean, inGrenade: boolean, inZone: boolean): boolean => masked && (inGrenade || inZone);

/** how much of grenade gas a gas mask's wearer (or whoever watches them) still sees: enough to steer round it */
export const GAS_SEEN_THROUGH_MASK = 0.3;

/** a particle's opacity, as this viewer sees it: grenade gas is faint through a gas mask, everything else as it is */
export const gasOpacityFor = (idString: string, viewerMasked: boolean): number => viewerMasked && idString === GAS_PUFF ? GAS_SEEN_THROUGH_MASK : 1;
